export enum AnimationType {
  FADE = 'fade',
  SLIDE = 'slide'
}
